export const WHATSAPP_NOTIFY_BY_VALUE = 'whatsapp';
export const WHATSAPP_MISSING_CUSTOMER_PHONE_MESSAGE =
  'Este cliente no tiene número de teléfono registrado. Para enviar la notificación por WhatsApp, actualiza el teléfono del cliente o cambia el método de notificación.';

export type WhatsappMissingCustomerPhoneOptions = {
  blockNewOrdersIfWhatsappCustomerPhoneMissing?: boolean;
  isUpdatingOrder?: boolean;
};

export const getCustomerPhoneValue = (customer: any): string => {
  const rawPhone = customer?.phone || customer?.phoneNumber || '';

  return String(rawPhone).trim();
};

export const getOrderCustomerPhone = (order: any): string => {
  const rawPhone =
    getCustomerPhoneValue(order?.customerInfo) ||
    order?.phone ||
    '';

  return String(rawPhone).trim();
};

export const hasCustomerPhoneForWhatsApp = (order: any): boolean => {
  return getOrderCustomerPhone(order).length > 0;
};

export const isWhatsappNotificationMissingCustomerPhone = (
  order: any,
  options: WhatsappMissingCustomerPhoneOptions = {}
): boolean => {
  if (options.isUpdatingOrder) return false;
  if (options.blockNewOrdersIfWhatsappCustomerPhoneMissing === false) return false;

  return (
    order?.notifyBy === WHATSAPP_NOTIFY_BY_VALUE &&
    !hasCustomerPhoneForWhatsApp(order)
  );
};
